// extracted by mini-css-extract-plugin
module.exports = {"renderWrapper":"b_b","renderContainer":"b_c","tabletContainer":"b_d"};